import { render, staticRenderFns } from "./PreviewFiles.vue?vue&type=template&id=0ea7c27c&"
import script from "./PreviewFiles.vue?vue&type=script&lang=js&"
export * from "./PreviewFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports